import { useMemo } from 'react'
import { FaStar } from 'react-icons/fa'

import {
  Container,
  ImageContainer,
  RatingContainer,
  Row,
  Image,
  SubTitle,
  InfoText,
} from './styles'

export default function Business ({
  data: business,
  onSelect: handleSelect = () => null
}) {
  const statusText = useMemo (() => {
    switch (business.status) {
      case 'active': return 'Ativo'
      case 'pending': return 'Pendente'
      case 'inactive': return 'Desativado pelo admin'
      case 'deleted': return 'Excluído pelo usuário'
      case 'archived': return 'Arquivado'
      default: return 'Desconhecido'
    }
  }, [business.status])

  const statusColor = useMemo (() => {
    switch (business.status) {
      case 'active': return '#44CF6C'
      case 'pending':
      case 'archived': return '#FFC100'
      default: return '#FF3939'
    }
  }, [business.status])

  return (
    <Container onClick={() => handleSelect (business)}>
      <Row>
        <ImageContainer>
          <Image src={business.logo}/>
          {business.ratings_count > 0 && (
            <RatingContainer>
              <FaStar size={12} color='#FFC100'/>
              <SubTitle>
                {business.average_rating}
              </SubTitle>
            </RatingContainer>
          )}
        </ImageContainer>
        <InfoText>
          {business.name}
        </InfoText>
      </Row>
      <SubTitle style={{color: statusColor}}>
        {statusText}
      </SubTitle>
    </Container>
  )
}
